import { Component, Input, OnInit } from "@angular/core";
import { CustomEventService } from "@shared/services/custom-event.service";
import { PropertiesService } from "@core/services/properties.service";
import ActionTypesEnum from "@shared/enums/action-constant.enum";

@Component({
  selector: 'app-selection-qwiser-modal',
  templateUrl: './selection-qwiser-modal.component.html'
})
export class SelectionQwiserModalComponent {
  @Input() selections: QWiser.Scope[] | QWiser.AddonModel[];
  @Input() custom: boolean;
  @Input() type: 'addon' | 'scope';
  @Input() extra?: string;

  isExclusion: boolean;

  constructor(private customEventService: CustomEventService,
              public propertiesService: PropertiesService) { }

  selected({ selectedItem, scopeId, $event }: { selectedItem: Gitwiser.AddonModel | Addon.Scope, scopeId?: string, $event?: any }): void {
    if ($event) {
      $event.stopPropagation();
    }

    if (this.type === 'addon') {
      if ('scopes' in  selectedItem && selectedItem.scopes && selectedItem.scopes.length && selectedItem.scopes.length === 1) {
        this.isExclusion = selectedItem.scopes.some(item => item.id === scopeId && (item.key === 'GIT' || item.key === 'DEFAULT'));
        this.customEventService.announceEvent(ActionTypesEnum.SHOW_NEW_ANALYSIS_QWISER_MODAL, {addonId: selectedItem.key, scopeId, isExclusion: this.isExclusion});
        this.customEventService.announceEvent(ActionTypesEnum.CLOSE_MODAL);
        return;
      }

      if ('scopes' in  selectedItem && selectedItem?.scopes && selectedItem.scopes.length >= 2) {
        if (scopeId) {
          this.isExclusion = selectedItem.scopes.some(item => item.id === scopeId && (item.key === 'GIT' || item.key === 'DEFAULT'));
          this.customEventService.announceEvent(ActionTypesEnum.SHOW_NEW_ANALYSIS_QWISER_MODAL, {addonId: selectedItem.key, scopeId, isExclusion: this.isExclusion});
          this.customEventService.announceEvent(ActionTypesEnum.CLOSE_MODAL);
          return;
        }
      }

      if ('showScopes' in  selectedItem && selectedItem.showScopes === false && !scopeId) {
        selectedItem.showScopes = true;
        return;
      }

      if ('showScopes' in  selectedItem && selectedItem.showScopes === true && !scopeId) {
        return;
      }

      if ('key' in selectedItem) {
        this.customEventService.announceEvent(ActionTypesEnum.SHOW_NEW_ANALYSIS_QWISER_MODAL, {
          addonId: selectedItem.key,
          scopeId
        });
      }
    }

    if (this.type === 'scope' && 'addonId' in selectedItem) {
      this.customEventService.announceEvent(ActionTypesEnum.ADDON_CREATE_WIDGET,
        {id: selectedItem.addonId, scopeId: selectedItem.id, dateFilterable: selectedItem.dateFilterable, displayType: selectedItem.displayType, custom: this.custom});
    }
    this.customEventService.announceEvent(ActionTypesEnum.CLOSE_MODAL);
  }

  close($event?: any, key?: string): void {
    if ($event && key) {
      $event.stopPropagation();

      const foundIndex: number = this.selections.findIndex(item => item.key === key);

      const foundSelection = this.selections[foundIndex];

      if (foundSelection && 'showScopes' in foundSelection) {
        foundSelection.showScopes = false;
      }
      return;
    }
    this.customEventService.announceEvent(ActionTypesEnum.CLOSE_MODAL);
  }

}
